import {SEND_MESSAGE, SET_CHATROOM_TITLE, SET_CHATROOM_MEMBERS, SET_ME, SET_CHATROOM_MESSAGES} from './types';

export const sendMessageAC = (messageObj) => {
    return {
        type: SEND_MESSAGE,
        payload: messageObj
    }
}

export const setChatroomTitleAC = (titleRoom) => {
    return {
        type: SET_CHATROOM_TITLE,
        payload: titleRoom
    }
}

export const setChatroomMembersAC = (allChatroomMembers) => {
    return {
        type: SET_CHATROOM_MEMBERS,
        payload: allChatroomMembers
    }
}

export const setMeAC = (visitor) => {
    return {
        type: SET_ME,
        payload: visitor
    }
}

export const setChatroomMessagesAC = (messagesArr) => {
    return {
        type: SET_CHATROOM_MESSAGES,
        payload: messagesArr
    }
}